import { Dispatch, SetStateAction } from 'react';

import { SshKeyFetch200 } from '@newfold/huapi-js/src/index.schemas';

import AddPublicKey from '~/apps/SSHKeyManager/components/AddPublicKey';
import DeleteKey from '~/apps/SSHKeyManager/components/DeleteKey';
import ViewKey from '~/apps/SSHKeyManager/components/ViewKey';
import { SSHKey } from '~/components/SSHKeysTable';

interface SSHKeysModalsProps {
  addOpen: boolean;
  setAddOpen: Dispatch<SetStateAction<boolean>>;
  defaultKeyName: string;
  selectedKey: SSHKey | null;

  viewOpen: boolean;
  setViewOpen: Dispatch<SetStateAction<boolean>>;
  viewKeyDetails: {
    keyData: SshKeyFetch200;
    createdAt: string;
  };
  isViewKeyLoading: boolean;

  deleteOpen: boolean;
  setDeleteOpen: Dispatch<SetStateAction<boolean>>;
  isRemoveAction?: boolean;
}

const SSHKeysModals = ({
  addOpen,
  setAddOpen,
  defaultKeyName,
  selectedKey,
  viewOpen,
  setViewOpen,
  deleteOpen,
  setDeleteOpen,
  isRemoveAction = false,
  viewKeyDetails,
  isViewKeyLoading,
}: SSHKeysModalsProps) => {
  const {
    name: keyName = '',
    id: keyId,
    authorize = false,
  } = selectedKey ?? {};

  return (
    <>
      <ViewKey
        keyDetails={viewKeyDetails}
        open={viewOpen}
        setOpen={setViewOpen}
        isSSHKeyLoading={isViewKeyLoading}
      />

      <DeleteKey
        open={deleteOpen}
        setOpen={setDeleteOpen}
        keyName={keyName}
        keyId={keyId}
        authorize={authorize}
        isRemoveAction={isRemoveAction}
      />

      <AddPublicKey
        key={String(addOpen)}
        open={addOpen}
        setOpen={setAddOpen}
        defaultKeyName={defaultKeyName}
      />
    </>
  );
};

export default SSHKeysModals;
